import moment from "moment";
import React from "react";
import TimelineItem from "./Item";
import { type TimelineItemInfo } from "./component";

const dateToFromNowDaily = (date: string): string => {
  // get from-now for this date
  var fromNow = moment(date).fromNow();

  // ensure the date is displayed with today and yesterday
  return moment(date).calendar(null, {
    // when the date is closer, specify custom values
    lastWeek: "[Last] dddd",
    lastDay: "[Yesterday]",
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    nextWeek: "dddd",
    // when the date is further away, use from-now functionality
    sameElse: function () {
      return "[" + fromNow + "]";
    }
  });
};

type Props = {
  createdOnDate: string;
  isDateHidden?: boolean;
  items: TimelineItemInfo[];
};
const TimelineGroup = ({ createdOnDate, items = [], isDateHidden }: Props) => (
  <li className="group">
    {!isDateHidden && <div className="header">{dateToFromNowDaily(createdOnDate)}</div>}
    <div className="group_items">
      {items.map((x, index) => (
        <TimelineItem key={index} item={x}></TimelineItem>
      ))}
    </div>
  </li>
);

export default TimelineGroup;
